import { SimError } from "./SimError.js";
class SimNoSuch extends SimError {
  constructor(message, name, stack) {
    super(message, name, stack);
  }
}
export {
  SimNoSuch
};
//# sourceMappingURL=SimNoSuch.js.map
